import { FillContainerLoadingMessage, useLanguage } from "@/lib/main";

export default function SuspenseFallback() {
  const { language } = useLanguage();

  return (
    <FillContainerLoadingMessage
      message={language === "ar" ? "يجري التحميل" : "Loading"}
    />
  );
}
